import React, { useState } from 'react';
import { Layout, Drawer, Dropdown, Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from '../../store/actions/auth';
import { NavLink } from 'react-router-dom';
import SideMenu from './SideMenu';
import { MenuIcon } from '@heroicons/react/outline';
import { motion } from 'framer-motion';
import { APP_TITLE } from '../../constants';
import { Footer } from 'antd/lib/layout/layout';

const { Header, Content } = Layout;

const DefaultLayout = ({ children }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const { auth } = useSelector((state) => state);

  const dispatch = useDispatch();

  const accountMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          dispatch(signOut());
        }}
      >
        Sign Out
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="bg-white layout">
      <Header
        className="flex justify-between items-center bg-white shadow-md"
        style={{
          position: 'fixed',
          zIndex: 1,
          width: '100%',
        }}
      >
        <div className="flex justify-center items-center">
          <div
            className="block md:hidden"
            onClick={() => {
              setDrawerVisible(!drawerVisible);
            }}
          >
            <MenuIcon
              className="mr-2 cursor-pointer hover:text-opacity-90"
              width={20}
            />
          </div>
          {/* Logo */}
          <div className="font-bold text-xl border-r pr-4 pb-1">
            {APP_TITLE}
          </div>

          {/* Nav */}
          <div className="hidden md:block pb-1">
            <nav className="mx-5 flex pt-1 gap-5">
              <NavLink
                exact
                className="flex justify-center items-center text-base text-black text-opacity-50"
                activeClassName="text-opacity-100 text-cyan-600 font-bold"
                to="/"
              >
                Home
              </NavLink>
              <NavLink
                exact
                className="flex justify-center items-center text-base text-black text-opacity-50"
                activeClassName="text-opacity-100 text-cyan-600 font-bold"
                to="/poaps"
              >
                Poaps
              </NavLink>

              {/* Admin routes */}
              {auth.user.admin && (
                <>
                  <NavLink
                    exact
                    className="flex justify-center items-center text-base text-black text-opacity-50"
                    activeClassName="text-opacity-100 text-cyan-600 font-bold"
                    to="/usuarios"
                  >
                    Usuarios
                  </NavLink>
                </>
              )}
            </nav>
          </div>
        </div>

        <div className="hidden md:flex gap-4">
          <div className="font-medium">{auth?.user?.name}</div>
          <Dropdown overlay={accountMenu} placement="bottomCenter">
            <div className="flex items-center">
              <img
                alt="avatar"
                src={`https://avatars.dicebear.com/api/identicon/${auth?.user?.username}.svg`}
                className="h-9 rounded-full cursor-pointer"
              />
            </div>
          </Dropdown>
        </div>
      </Header>

      <Content className="lg:flex justify-center py-5">
        <motion.div
          initial={{ opacity: 0, x: -500 }}
          animate={{ opacity: 1, x: 0, transition: { ease: 'anticipate' } }}
          exit={{ opacity: 0, x: 0 }}
          style={{ paddingTop: 64 }}
          className="lg:container"
        >
          {children}
        </motion.div>
      </Content>

      <Drawer
        title="Menu"
        placement="left"
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        className="mx-0"
      >
        <SideMenu auth={auth} />
      </Drawer>
    </Layout>
  );
};

export default DefaultLayout;
